import React from 'react';
import { useParams } from 'react-router';
import { useContext, useEffect, useRef, useState } from 'react';
import styles from './styles.js';
import useRoom from '../../hooks/useRoom';
import { UserContext } from '../../context/UserContext';
import ToolBar from 'components/ToolBar';
import NetworkToast from 'components/NetworkToast';
import useScreenSharing from '../../hooks/useScreenSharing';
import { getCredentials } from 'api/fetchCreds.js';
import SideMenu from '../SideMenu';
import useSignal from '../../hooks/useSignal';
import axios from 'axios';
export default function VideoRoom() {
  const { user } = useContext(UserContext);
  const [credentials, setCredentials] = useState(null);
  const [error, setError] = useState(null);
  const {
    createCall,
    room,
    participants,
    connected,
    networkStatus,
    cameraPublishing,
    localParticipant,
    audioPublishing,
    layoutSignal,
  } = useRoom();
  const { isScreenSharing, startScreenSharing, stopScreenSharing } =
    useScreenSharing({ room });
  const roomContainer = useRef();
  const classes = styles();
  let { pid, userName, userId, roleName } = useParams();
  const { listOfMessages } = useSignal({ room });
  const localClasses = styles();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});

  const postSessionId = async (sessionId) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/v2/video/media/livemeeting/session/${pid}`,
        {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    getCredentials(pid, roleName, userName, userId)
      .then(({ data }) => {
        postSessionId(data.sessionId);
        setCredentials({
          apikey: data.apiKey,
          sessionId: data.sessionId,
          token: data.token,
          roleName: data.roleName,
        });
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  }, [pid]);

  useEffect(() => {
    const userData = sessionStorage.getItem('userData');
    if (userData !== 'undefined') {
      const data = JSON.parse(userData);
      setData(data);
    }
  }, []);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, []);

  useEffect(() => {
    if (credentials) {
      sessionStorage.setItem('meetingSessionId', credentials?.sessionId);
      createCall(
        credentials,
        roomContainer.current,
        data?.name || user.userName || userName,
        user.videoFilter,
        {
          ...user.defaultSettings,
        }
      );
    }
  }, [createCall, credentials, user]);

  if (error)
    return (
      <div className={classes.errorContainer}>
        There was an error fetching the data from the server
      </div>
    );

  return (
    <div className={classes.childDrawer}>
      <div id='callContainer' className={classes.callContainer}>
        <div
          id='roomContainer'
          className={classes.roomContainer}
          ref={roomContainer}
        >
          <NetworkToast networkStatus={networkStatus} />
          <div
            id='screenSharingContainer'
            className={classes.screenSharingContainer}
          >
            {isScreenSharing && (
              <div className={classes.screenSharingOverlay}>
                You Are Screensharing
              </div>
            )}
          </div>
        </div>
        <ToolBar
          room={room}
          participants={participants}
          localParticipant={localParticipant}
          connected={connected}
          cameraPublishing={cameraPublishing}
          isScreenSharing={isScreenSharing}
          startScreenSharing={startScreenSharing}
          stopScreenSharing={stopScreenSharing}
          audioPublishing={audioPublishing}
          open={open}
          setOpen={setOpen}
          layoutSignal={layoutSignal}
          participantId
        />
      </div>
      {(roleName == 'host' || roleName == 'guest') && (
        <SideMenu
          className={localClasses.root}
          room={room}
          participants={participants}
          localParticipant={localParticipant}
          listOfMessages={listOfMessages}
          isOpen={open}
          pid={pid}
          userid={userName}
        ></SideMenu>
      )}
    </div>
  );
}
